<template>
  <div>
    <h1>Historial de modificaciones a tarifa base</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-table
          show-empty
          stacked="md"
          :items="getAllFares"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          @filtered="onFiltered"
          empty-text="No existen registros por mostrar"
          emptyFilteredText="No existen registros por mostrar"
        >
        <template v-slot:cell(appCharge)="row">
          {{ row.item.appCharge * 100 + ' %' }}
        </template>
        <template v-slot:cell(nightFare)="row">
          {{ row.item.nightFare * 100 + ' %' }}
        </template>
        <template v-slot:cell(timeFare)="row">
          {{ '$' + row.item.timeFare }}
        </template>
        <template v-slot:cell(startedPrice)="row">
          {{ '$' + row.item.startedPrice }}
        </template>
        <template v-slot:cell(distanceShortFare)="row">
          {{ '$' + row.item.distanceShortFare }}
        </template>
        <template v-slot:cell(distanceLongFare)="row">
          {{ '$' + row.item.distanceLongFare }}
        </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllFares.loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_ALL_FARES = gql`
query getAllFares{
  getAllFares{
    id
    createdBy
    appCharge
    startedPrice
    date
    distanceLongFare
    distanceShortFare
    nightFare
    timeFare
  }
}
`
export default {
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      // sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      // getAllFares: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'date', label: 'Fecha' },
        { key: 'createdBy', label: 'Responsable' },
        { key: 'appCharge', label: 'Comisión por uso de aplicación' },
        { key: 'startedPrice', label: 'Costo de banderazo' },
        { key: 'timeFare', label: 'Costo por tiempo' },
        { key: 'distanceShortFare', label: 'Costo por distancia 1' },
        { key: 'distanceLongFare', label: 'Costo por distancia 2' },
        { key: 'nightFare', label: 'Porcentaje de tarifa nocturna' },
      ],
    }
  },
  apollo: {
    getAllFares: {
      query: GET_ALL_FARES,
      result({ data }) {
        // console.log(data.getAllFares)
        if (data.getAllFares != null) {
          this.getAllFares = data.getAllFares.sort(function (a, b) {
            return b.id - a.id
          })
          this.totalRows = data.getAllFares.length
        }
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    refetchQuery() {
      this.$apollo.queries.getAllFares.refetch()
    },
  },
}
</script>
